import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from '../features/auth/slice';
import { artistReducer } from '../features/artist/slice';

const rootReducer = combineReducers({
  auth: authReducer,
  artist: artistReducer,
});

export const reducer = (state, action) => {
  switch (action.type) {
    default:
      return rootReducer(state, action);
  }
};

export default reducer;
